import { render } from "./g-entity-popup.vue?vue&type=template&id=772d5e40&ts=true"
import script from "./g-entity-popup.vue?vue&type=script&lang=tsx"
export * from "./g-entity-popup.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__